import { render, staticRenderFns } from "./addInvoce.vue?vue&type=template&id=21869bec"
import script from "./addInvoce.vue?vue&type=script&lang=js"
export * from "./addInvoce.vue?vue&type=script&lang=js"
import style0 from "./addInvoce.vue?vue&type=style&index=0&id=21869bec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports